import React from "react";
import { useTranslation } from "react-i18next";
import { formatDayLabel } from "./utils";

/** "Today" / "Yesterday" / "Monday 3 August" pill between thread days. */
export const DaySeparator: React.FC<{ date: Date }> = ({ date }) => {
	const { t, i18n } = useTranslation();
	const label = formatDayLabel(
		date,
		i18n.language,
		t("inbox.today", "Today"),
		t("inbox.yesterday", "Yesterday")
	);

	return (
		<div className="my-4 flex items-center gap-3" role="separator" aria-label={label}>
			<span className="h-px flex-1 bg-border" />
			<span className="rounded-full bg-muted px-3 py-0.5 text-xs font-medium text-muted-foreground">
				{label}
			</span>
			<span className="h-px flex-1 bg-border" />
		</div>
	);
};
